import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

const creditPackagesService = {
    /**
     * Get all available credit packages
     * @returns {Promise<{success: boolean, data: {packages: Array, currency: string, totalPackages: number}}>}
     */
    async getPackages() {
        try {
            const tokens = getTokens();
            const response = await axiosInstance.get('/api/monetization/packages', {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching credit packages:', error);
            throw error;
        }
    },

    /**
     * Purchase a credit package
     * @param {string} packageId - The ID of the package to purchase
     * @param {string} paymentMethod - Payment method ('ccbill' | 'stripe', defaults to 'ccbill')
     * @returns {Promise<{success: boolean, data: any, message: string}>}
     */
    async purchasePackage(packageId, paymentMethod = 'ccbill') {
        try {
            const tokens = getTokens();
            const response = await axiosInstance.post('/api/monetization/credits/purchase', {
                packageId,
                paymentMethod
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error purchasing credit package:', error);
            throw error;
        }
    }
};

export default creditPackagesService;
